export default __webpack_public_path__ + "static/media/icon-points.76d06977.svg";